var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "variable-container",
    style: {
      background: _vm.bgColor
    }
  }, [_c("div", {
    staticClass: "marginB5"
  }, [_vm._v(_vm._s(_vm.$t("该场景可使用以下变量，点击可复制变量code")))]), _vm.textVariable.length > 0 ? _c("div", {
    staticClass: "marginB5"
  }, [_vm._v(_vm._s(_vm.$t("文本变量:")))]) : _vm._e(), _vm.textVariable.length > 0 ? _c("div", {
    staticClass: "btn-container"
  }, _vm._l(_vm.textVariable, function (item) {
    return _c("a-tag", {
      key: item.mark,
      staticClass: "tag-btn",
      staticStyle: {
        cursor: "pointer"
      },
      attrs: {
        color: "blue"
      },
      on: {
        "!click": function ($event) {
          $event.stopPropagation();
          return _vm.copyVariable(item);
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.$t(item.name) + "{" + item.mark + "}") + " ")]);
  }), 1) : _vm._e(), _vm.linkVariable.length > 0 && _vm.scenc === "INTERNAL_MAIL" ? _c("div", {
    staticClass: "marginB10"
  }, [_vm._v(_vm._s(_vm.$t("链接变量:")))]) : _vm._e(), _vm.linkVariable.length > 0 && _vm.scenc === "INTERNAL_MAIL" ? _c("div", {
    staticClass: "btn-container"
  }, _vm._l(_vm.linkVariable, function (item) {
    return _c("a-tag", {
      key: item.mark,
      staticClass: "tag-btn",
      staticStyle: {
        cursor: "pointer"
      },
      attrs: {
        color: "blue"
      },
      on: {
        "!click": function ($event) {
          $event.stopPropagation();
          return _vm.copyVariable(item);
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.$t(item.name) + "{" + item.mark + "}") + " ")]);
  }), 1) : _vm._e()]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };